/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tag associated with notes
 * @export
 * @interface TagNoteDto
 */
export interface TagNoteDto {
    /**
     * Unique identifier of the tag
     * @type {string}
     * @memberof TagNoteDto
     */
    id?: string;
    /**
     * Label of the tag
     * @type {string}
     * @memberof TagNoteDto
     */
    label?: string;
    /**
     * Color code for the tag (hex format)
     * @type {string}
     * @memberof TagNoteDto
     */
    color?: string;
    /**
     * True if global tag, False if custom tag
     * @type {boolean}
     * @memberof TagNoteDto
     */
    isGlobal?: boolean;
}

/**
 * Check if a given object implements the TagNoteDto interface.
 */
export function instanceOfTagNoteDto(value: object): value is TagNoteDto {
    return true;
}

export function TagNoteDtoFromJSON(json: any): TagNoteDto {
    return TagNoteDtoFromJSONTyped(json, false);
}

export function TagNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagNoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'] == null ? undefined : json['label'],
        'color': json['color'] == null ? undefined : json['color'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
    };
}

export function TagNoteDtoToJSON(json: any): TagNoteDto {
    return TagNoteDtoToJSONTyped(json, false);
}

export function TagNoteDtoToJSONTyped(value?: TagNoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'color': value['color'],
        'isGlobal': value['isGlobal'],
    };
}

